import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@getgo/chameleon-web/react';
import classNames from 'classnames';
import { useRef, useState } from 'react';
import { shouldInvertText, TOKEN_INVERSE_TEXT, TOKEN_PRIMARY_TEXT } from '../../../../utils/colors';
import classes from './WebChatSmartResponseSelectQuestionEvent.module.scss';
export const WebChatSmartResponseSelectQuestionEvent = ({ color, options, onSmartResponsesSubmit, disabled }) => {
    let style = null;
    const ref = useRef(null);
    const [answer, setAnswer] = useState(null);
    if (color) {
        style = {
            alignItems: 'center',
            backgroundColor: 'var(--goto-ui-background)',
            borderColor: color,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            '--goto-icon-color': color,
        };
    }
    const buttonStyle = Object.assign(Object.assign({}, style), { '--goto-icon-color': color, '--goto-border': color, '--goto-interactive-01': color, '--goto-link': `var(--goto-${TOKEN_PRIMARY_TEXT})`, '--goto-text-06': shouldInvertText(TOKEN_INVERSE_TEXT, color, TOKEN_PRIMARY_TEXT, ref.current) &&
            `var(--goto-${TOKEN_PRIMARY_TEXT})` });
    return (_jsx("ul", Object.assign({ ref: ref, className: classNames(classes.options) }, { children: options.map(({ reference, label }) => (_jsx("li", Object.assign({ className: classes.option }, { children: _jsx(Button, Object.assign({ variant: answer === reference + '' ? 'primary' : 'secondary', className: classNames(classes.button, (answer || disabled) && classes.alreadyPicked), onClick: () => {
                    setAnswer(reference);
                    onSmartResponsesSubmit === null || onSmartResponsesSubmit === void 0 ? void 0 : onSmartResponsesSubmit(reference);
                }, disabled: disabled || (answer && answer !== reference + ''), style: buttonStyle }, { children: label }), void 0) }), reference))) }), void 0));
};
//# sourceMappingURL=index.js.map